import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCalendarRoute: InvariantJiraRoute = {
	name: 'servicedesk-calendar',
	path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
	exact: true,
};
